import { render, staticRenderFns } from "./KeyHandling2.vue?vue&type=template&id=d317d100&"
import script from "./KeyHandling2.vue?vue&type=script&lang=js&"
export * from "./KeyHandling2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports